<template>
    <nav
        class="navbar has-shadow is-fixed-top lb-app-navbar"
        role="navigation"
        aria-label="main navigation"
    >
        <div class="navbar-brand">
            <router-link :to="'/'" class="navbar-item is-marginless">
                <img
                    src="@/assets/images/Labylok.gif"
                    alt
                    width="112"
                    height="28"
                />
            </router-link>
            <mq-layout mq="mobile" class="container">
                <app-navbar-user-menu class="is-pulled-right" />
            </mq-layout>
            <a
                role="button"
                class="navbar-burger burger"
                aria-label="menu"
                aria-expanded="false"
                data-target="navbar"
                @click="menuActive = !menuActive"
            >
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </div>

        <div
            id="navbar"
            :class="{ 'is-active': menuActive }"
            class="navbar-menu"
            @click="menuActive = false"
        >
            <div class="navbar-start">
                <router-link
                    v-if="isLoggedIn && !$store.getters.isAnonymous"
                    :to="{
                        path: '/dashboard',
                        query: {
                            filter: 'mine',
                        },
                    }"
                    tag="a"
                    class="navbar-item has-text-centered-mobile"
                    >{{ $t('Navbar.myspace') }}</router-link
                >
                <router-link
                    tag="a"
                    class="navbar-item has-text-centered-mobile"
                    to="/explore"
                    >{{ $t('Navbar.explore') }}</router-link
                >
                <router-link
                    v-if="isLoggedIn && !$store.getters.isAnonymous"
                    tag="a"
                    class="navbar-item has-text-centered-mobile"
                    to="/creation"
                    >{{ $t('Navbar.create') }}</router-link
                >
                <router-link
                    v-if="isLoggedIn && $store.getters.isAdmin"
                    tag="a"
                    class="navbar-item has-text-centered-mobile"
                    to="/inspirations"
                    >{{ $t('Navbar.inspirations') }}</router-link
                >
                <!--<a
                    v-if="isLoggedIn"
                    class="navbar-item has-text-centered-mobile"
                    @click="$emit('update:active', true)"
                >{{ $t('play_session') }}</a>-->

                <a
                    v-if="isLoggedIn"
                    class="navbar-item has-text-centered-mobile"
                    :href="playUrl"
                    target="_blank"
                    >{{ $t('play_session') }}</a
                >
            </div>

            <div class="navbar-end">
                <mq-layout mq="tablet+">
                    <app-navbar-user-menu />
                </mq-layout>
            </div>
        </div>
    </nav>
</template>

<script>
import AppNavbarUserMenu from '@/components/AppNavbarUserMenu';
export default {
    components: {
        AppNavbarUserMenu,
    },
    props: {
        active: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            menuActive: false,
        };
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        location() {
            return location;
        },
        playUrl() {
            return process.env.VUE_APP_PLAY_URL + '/?lang=' + this.$i18n.locale;
        },
    },
    methods: {
        async login() {
            let loginURL = new URL(
                'https://accounts.google.com/o/oauth2/v2/auth'
            );
            let params = new URLSearchParams(loginURL.search.slice(1));
            params.append('access_type', 'offline');
            params.append('include_granted_scopes', true);
            params.append(
                'redirect_uri',
                process.env.VUE_APP_GOOGLE_REDIRECT_URI
            );
            params.append('client_id', process.env.VUE_APP_GOOGLE_CLIENT_ID);
            params.append('response_type', 'code');
            params.append('scope', 'email profile openid');
            params.append('prompt', 'consent');
            window.location = `${loginURL}?${params.toString()}`;

            return;
            let gapi = await this.$gapi.getGapiClient();
            let auth2 = gapi.auth2.getAuthInstance();
            if (this.$gapi.isAuthenticated()) {
                console.log('authtthhe');
                this.$router.push({
                    name: 'login',
                    params: auth2.currentUser.get().getAuthResponse(),
                });
            } else {
                // this.$gapi.login(async res => {
                let googleUser = auth2.currentUser.get();
                console.log(googleUser);
                let f = await googleUser
                    .grant({
                        scope: 'https://www.googleapis.com/auth/classroom.coursework.me',
                    })
                    .then((e) => {
                        console.log('result', e);
                    });
                console.log(f);
                this.$router.push({
                    name: 'login',
                    params: googleUser.getAuthResponse(),
                });
                // });
            }
        },
    },
};
</script>

<style scoped>
.lb-app-navbar {
    z-index: 31 !important;
}
</style>
